<div class="squirrel_arrow_right-icon">
  <svg class="pl_icon" role="img">
    <use xlink:href="/assets-static/icons/pl_icon_arrow-right.svg#pl_icon_arrow-right"></use>
  </svg>
</div>

<style lang="scss">
  @use "~@otto-ec/global-frontend-settings/scss/pl_variables" as pl_variables;

  .squirrel_arrow_right-icon {
    color: #000;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    top: 0;
    right: 0;
    padding: 12px 16px;
  }

  svg {
    flex: 0 0 24px;
    fill: pl_variables.$pl_color-red100;
    height: 24px;
    width: 24px;
  }
</style>
